import { ActionType } from "../ChatAction";
import { ConnectionState } from "../ChatState";

export default function connectionReducer(state: ConnectionState, action: ActionType): ConnectionState {
    switch (action.type) {
        case "connection_update":
            return {
                ...state,
                connectionStatus: action.detail.status
            };

        case "receiveToken":
            return {
                ...state,
                token: action.detail.token
            };

        case "sendGreeting":
            return {
                ...state,
                greetingRequested: true
            };
    }

    return state;
}
